export interface ModalBasicActions {
  show: Function;
  hide: Function;
}
